import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import HeaderCard from "../../Common/HeaderCard";

import cx from "classnames";
import TreeView, { flattenTree } from "react-accessible-treeview";
import { FaCheckSquare, FaMinusSquare, FaSquare } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import { TREE_VIEW } from "../../../Data/Bonus-ui/Data";

export const ArrowIcon = ({ isOpen, className }) => {
  const baseClass = "arrow";
  const classes = cx(baseClass, { [`${baseClass}--closed`]: !isOpen }, { [`${baseClass}--open`]: isOpen }, className);
  return <IoMdArrowDropright className={classes} />;
};

export const CheckBoxIcon = ({ variant, ...rest }) => {
  switch (variant) {
    case "all":
      return <FaCheckSquare color="#4AAD8A" {...rest} />;
    case "none":
      return <FaSquare color="white" {...rest} style={{ border: "1px solid #80808069" }} />;
    case "some":
      return <FaMinusSquare {...rest} color="#33BFBF" />;
    default:
      return null;
  }
};
const BasicTree = () => {
  const treeData = flattenTree(TREE_VIEW);
  return (
    <Fragment>
      <Col sm="6">
        <Card>
          <HeaderCard title="Basic Tree" />
          <CardBody>
            <TreeView
              data={treeData}
              aria-label="Checkbox tree"
              multiSelect
              propagateSelect
              propagateSelectUpwards
              togglableSelect
              expandedIds={[1, 2, 6, 10]}
              nodeRenderer={({ element, isBranch, isExpanded, isSelected, isHalfSelected, getNodeProps, level, handleSelect, handleExpand }) => {
                return (
                  <div {...getNodeProps({ onClick: handleExpand })} style={{ marginLeft: 40 * (level - 1), marginTop: 5 }} className="d-flex align-items-center">
                    {isBranch && <ArrowIcon isOpen={isExpanded} />}
                    <CheckBoxIcon
                      className="checkbox-icon "
                      onClick={(e) => {
                        handleSelect(e);
                        e.stopPropagation();
                      }}
                      variant={isHalfSelected ? "some" : isSelected ? "all" : "none"}
                    />
                    <span className="name">{element.name}</span>
                  </div>
                );
              }}
            />
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default BasicTree;
